import { Box, List, Typography } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached.tsx";
import PopoverMenuItem from "@entrilia/shared/components/PopoverMenuItem";
import NewLabel from "../../../../common/NewLabel.tsx";
import type { MenuItemRecord } from "./MenuItemRecord.ts";

interface Props {
  items: MenuItemRecord[];
  selectedItem: MenuItemRecord;
  subHeader?: string;
  showNewLabel?: boolean;
  onClick: (item: MenuItemRecord) => void;
}
export default function TemplatesMenuItem({ items, selectedItem, subHeader, onClick, showNewLabel }: Props) {
  if (items.length === 0) return null;

  return (
    <List subheader={subHeader && <Typography variant="subtitle2">{subHeader}</Typography>}>
      {items.map((item) => {
        return (
          <PopoverMenuItem
            key={item.value}
            sx={{ py: 0.5, borderRadius: "4px", letterSpacing: "0.17px" }}
            selected={item.label === selectedItem.label && item.fieldName === selectedItem.fieldName}
            onClick={() => onClick(item)}
          >
            <Typography sx={{ flex: 1, textAlign: "left", py: 0.5 }}>{item.label}</Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              {showNewLabel && item.isNew && <NewLabel />}
              <BadgeDetached
                showZero
                badgeContent={item.count}
                color={
                  item.label === selectedItem.label && item.fieldName === selectedItem.fieldName
                    ? "primary"
                    : "secondary"
                }
                sx={{ width: 32, justifyContent: "center" }}
              />
            </Box>
          </PopoverMenuItem>
        );
      })}
    </List>
  );
}
